const statusColors = Object.freeze({
  Green: 'green',
  Yellow: 'yellow',
  Orange: 'orange',
  Red: 'red',
  None: '',
});

export default statusColors;
